module.exports = __webpack_public_path__ + "img/icons8-jeep.2a9760cd.svg";